import React from "react";
import GamTemplate from "./gam_template";

const Template = (props) => {
  const templates = {
    gam: GamTemplate,
  };

  const TemplateComponent = templates[props.service];
  const renderTemplate = <TemplateComponent {...props} />;
  return <>{renderTemplate}</>;
};

export default Template;
